import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import {setFiberPackageCode} from './FiberProductCardSlice';
import {connect} from 'react-redux';

const cutPackageName = (packageName) => {
  const name = packageName.substring(0, packageName.lastIndexOf(' '));
  return name;
};
const cutPackageLastWord = (packageName) => {
  const volume = packageName.split(' ').splice(-1);
  return volume;
};

const fiberProductCard = (props) => {
  useEffect(() => {
    if (props.fiberProductId != '') {
      props.onProdUpgrade({productId: props.fiberProductId, isChecked: props.isSelectedBtn});
    }
  }, [props.fiberProductId, props.isSelectedBtn]);

  return (
    <Container className='fiberProductCard'>
      <Row>
        <Col>
          <Row>
            <Col className='fiber-card-enlarge'>
              <span>הגדלת חבילה</span>
            </Col>
          </Row>
          <Row>
            <Col className='fiber-card-name'>
              <span>{cutPackageName(props.data.name) + ' '}</span>
              <span>{cutPackageLastWord(props.data.name)}</span>
            </Col>
          </Row>
          <Row>
            <Col xs='5' md='6' className='fiber-include'>
              <div className='fiber-include-title'>הורדה עד </div>
              <div className='fiber-include-details'>{props.data.downloadSpeed} Mbps</div>
            </Col>
            <Col xs='1' md='1' className='separator'></Col>
            <Col xs='5' md='5' className='fiber-include'>
              <div className='fiber-include-title'> העלאה עד </div>
              <div className='fiber-include-details'>{props.data.uploadSpeed} Mbps </div>
            </Col>
          </Row>
          <Row className='fiber-upgrade'>
            <Col xs='8' md='8'>
              <div className='upgrade-price'>
                <span>₪{props.data.additionalPrice}</span>
                <span> לחודש בלבד</span>
              </div>
            </Col>
            <Col xs='4' md='4' className='btn-upgrade-holder'>
              <BtnWhite
                text={
                  props.isSelectedBtn && props.packageIndex == props.idx ? (
                    <Image src={require('./images/shape.svg')} alt='נבחר' />
                  ) : (
                    <span>לשדרוג</span>
                  )
                }
                onclick={() => {
                  props.orderEvent
                    ? props.orderEvent()
                    : props.setFiberPackageCode({
                        fiberProdId: props.data.productId,
                        packageIndex: props.idx,
                      });
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm='12' className='fiber-terms'>
              <a href={props.data.productTermsLink} target='_blank'>
                תנאי החבילה
              </a>
              <Image src={require('./images/arrow.svg')} alt='חץ' />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    fiberProductId: state.FiberProductCard.fiberProductId,
    isSelectedBtn: state.FiberProductCard.isSelectedBtn,
    packageIndex: state.FiberProductCard.packageIndex,
  };
};

const mapDispatchToProps = {setFiberPackageCode};

export default connect(mapStateToProps, mapDispatchToProps)(fiberProductCard);
